import { PopoutMenu } from '../../menu/popout-menu/popout-menu.tsx'

type BladeMediaMenuProps = {
  canDelete?: boolean
  canView?: boolean
  onDelete: () => void
  onView?: () => void
}

const BladeMediaMenu = ({
  canDelete,
  canView,
  onDelete,
  onView,
}: BladeMediaMenuProps) => {
  return (
    (canDelete || canView) && (
      <PopoutMenu
        dataTestId="blade-media-dropdown-menu"
        dataTrackingId="blade-media-dropdown-menu"
      >
        {canView && (
          <PopoutMenu.Item
            leftIcon={{ name: 'EyeIcon', fill: 'solid', color: 'info' }}
            onClick={onView}
            dataTestId="blade-media-view"
            dataTrackingId="blade-media-view"
          >
            View
          </PopoutMenu.Item>
        )}
        {canDelete && (
          <PopoutMenu.Item
            leftIcon={{ name: 'TrashIcon', fill: 'solid', color: 'negative' }}
            onClick={onDelete}
            dataTestId="blade-media-delete"
            dataTrackingId="blade-media-delete"
          >
            Delete
          </PopoutMenu.Item>
        )}
      </PopoutMenu>
    )
  )
}

export { BladeMediaMenu, type BladeMediaMenuProps }
